import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import { useCallback, useContext } from 'react'

import { Page } from '@/types/page'
import cn from '@/utils/tailwind/cn'

type Props = {
  page: Page
  type: string
}
export const BuilderHeaderRepeatSection = ({ page, type }: Props) => {
  const { getIsSelected, setSelectedItem } = useContext(FormBuilderContext)

  const isSelected = getIsSelected(page.id, type)

  const onSelectClick = useCallback(() => {
    setSelectedItem({ id: page.id, type })
  }, [page.id, type, setSelectedItem])

  return (
    <span
      className={cn(
        'repeating-section-title absolute -top-8 left-4 w-[calc(100%-2rem)] cursor-pointer rounded-t-md border !border-b-0 !border-dashed !border-gray-300 bg-white px-3 py-1 text-gray-600 transition duration-150',
        isSelected && 'text-blue-500'
      )}
      onClick={onSelectClick}
    >
      {page?.title || 'Repeating Section'}
    </span>
  )
}
